import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { injectIntl } from "react-intl";
import { createSelector } from 'reselect';

import DeleteItemsComponent from './DeleteItems';
import { deleteFeeScheduleItems } from '../../../../../../../store/actions/feeScheduleItems';
import { setV2 } from '../../../../../../../store/actions/pagesV2';

export const DeleteItems = connect(
    (state, props) => {
        const pageName = props.isGlobal ? 'global-feeschedule-items-landing' : 'feeschedule-items-landing';
        const pageData = state.pages[pageName] || {};
        return {
            selectedItems: state.pagesV2[pageName]?.selected || [],
            filters: pageData.filter,
            page: pageData.page,
            sort: pageData.sort,
            feeScheduleId: state.contracts.feeSchedule?.id,
            deletePending: state.feeScheduleItems?.deleteFeeScheduleItems?.pending
        };
    },
    (dispatch, props) => {
        const pageName = props.isGlobal ? 'global-feeschedule-items-landing' : 'feeschedule-items-landing';
        return {
            actions: bindActionCreators({
                deleteFeeScheduleItems: deleteFeeScheduleItems,
                setSelected: (value) => setV2(pageName, 'selected', value)
            }, dispatch)
        };
    }
)(injectIntl(DeleteItemsComponent));